import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Menu,
  X,
  LayoutDashboard,
  Users,
  Gamepad2,
  ChevronDown,
  ChevronRight,
  LogOut,
  PlusCircle,
  List,
  History,
  ArrowDownCircle,
  ArrowUpCircle,
  BookPlus,
  ChevronUp,
} from "lucide-react";
import { PiGameControllerFill } from "react-icons/pi";
import { FaCashRegister } from "react-icons/fa"
import { TbCashRegister } from "react-icons/tb";
import { RiShieldUserFill } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import {
  PiHandWithdraw,
  PiHandWithdrawFill,
  PiHandWithdrawBold,
  PiHandDeposit,
  PiHandDepositBold,
  PiHandDepositFill,
  PiWallet,
} from "react-icons/pi";
import { GiPayMoney } from "react-icons/gi";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";
import { MdOutlineGppBad } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";
import { FaTachometerAlt } from "react-icons/fa";
import { GiAmericanFootballPlayer } from "react-icons/gi";
import { FaUserShield } from "react-icons/fa";
import { LiaHandHoldingUsdSolid } from "react-icons/lia";
import { MdAdminPanelSettings } from "react-icons/md";

import { GiLevelEndFlag } from "react-icons/gi";
interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});
  const sidebarRef = useRef<HTMLDivElement>(null);
  const role = localStorage.getItem("role");
  const activeTab = localStorage.getItem("active_tab");

  const toggleExpand = (section: string) => {
    setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
    toggleSidebar();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        toggleSidebar();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);

  const menuItems = [
    {
      to: "/",
      label: "Dashboard",
      icon: FaTachometerAlt,
      allowed: activeTab === "B2C" && role === "admin",
    },
    {
      to: "/game-control",
      label: "Game Control",
      icon: FaTachometerAlt,
      allowed: activeTab === "B2C" && role === "admin",
    },
    {
      label: "Transactions",
      icon: BiTransferAlt,
      expandable: true,
      section: "Transactions",
      allowed: activeTab === "B2C"  && role === "admin",
      subItems: [
        {
          to: "/Deposits",
          label: "Deposits",
          icon: PiWallet,
        },
        {
          to: "/manual-withdrawal",
          label: "Withdrawal",
          icon: GiTakeMyMoney,
        },
      ],
    },

    {
      to: "/users",
      label: "Players",
      icon: GiAmericanFootballPlayer,
      allowed: activeTab === "B2C" && role === "admin",
    },
    // {
    //   to: "/subordinate",
    //   label: "Admins",
    //   icon: FaUserShield,
    //   allowed: activeTab === "B2C",
    // },
   {
      to: "/panelgames",
      label: "Games",
      icon: PiGameControllerFill,
      allowed: activeTab === "B2C" && role === "admin",
    },
    // { to: "/house", label: "Game Control", icon: Gamepad2, allowed: true },
    // {
    //   label: "Deposits",
    //   icon: PiWallet,
    //   expandable: true,
    //   section: "payment",
    //   allowed: activeTab === "B2B" ,
    //   subItems: [
    //     { to: "/web-deposits", label: "Website Deposits", icon: PiHandDeposit },
    //   ],
    // },

   
    
    // {
    //   to: "/B2BPaymentSettings",
    //   label: "B2B Payment Settings",
    //   icon: BookPlus,
    //   allowed: activeTab === "B2C",
    // },

    // {
    //   to: "/level",
    //   label: "Level",
    //   icon: SiLevelsdotfyi,
    //   allowed: activeTab === "B2C" && role === "admin",
    // },
    // {
    //   to: "/depositBonus",
    //   label: "Set Deposit Bonus",
    //   icon: GiPayMoney,
    //   allowed: activeTab === "B2C" && role === "admin",
    // },
    // {
    //   to: "/BetCommissionLevel",
    //   label: "Bet Commission",
    //   icon: GiLevelEndFlag,
    //   allowed: activeTab === "B2C" && role === "admin",
    // },
    // {
    //   to: "/DepositCommissionLevel",
    //   label: "DepositCommission",
    //   icon: LiaHandHoldingUsdSolid,
    //   allowed: activeTab === "B2C" && role === "admin",
    // },
    // {
    //   to: "/stateList",
    //   label: "State Restrictions",
    //   icon: MdOutlineGppBad,
    //   allowed: activeTab === "B2C" && role === "admin",
    // },
    //  {

    //   label: "Settings",
    //   icon: IoSettingsOutline,
    //   expandable: true,
    //   section: "setting",
    //   allowed: activeTab === "B2C" && role === "admin",
    //   subItems: [
    //     { to: "/settings", label: "Setting", icon: History },
    //     { to: "/changePassword", label: "Change Password", icon: History },
    //   ],
    // },
    {
      label: "Settings",
      icon: IoSettingsOutline,
      to: "/setting",
      section: "setting",
      allowed: activeTab === "B2C" && role === "admin",
    },
    {
      label: "My Profile",
      icon: RiShieldUserFill,
      to: "/profile",
      section: "My Profile",
      allowed: activeTab === "B2C",
    },
    // {
    //   label: "Website Banners",
    //   icon: MdOutlineAdminPanelSettings,
    //   to: "/banners",
    //   section: "Website Banners",
    //   allowed: activeTab === "B2C" && role === "admin",
    // },

    {
      label: "Website Settings",
      icon: PiWallet,
      expandable: true,
      section: "websiteSettings",
      allowed: activeTab === "B2C",
      subItems: [

         {
          to: "/WcApiConfig",
          label: "Api Config",
          icon: PiHandDeposit,
        },
        // {
        //   to: "/banners",
        //   label: "Banners",
        //   icon: MdOutlineAdminPanelSettings,
        // },
        // {
        //   to: "/Banking",
        //   label: "Banking",
        //   icon: PiHandDeposit,
        // },
        {
          to: "/banking/usdt",
          label: "USDT Banking",
          icon: PiHandDeposit,
        },
        // {
        //   to: "/stateList",
        //   label: "State Reg",
        //   icon: PiHandDeposit,
        // },
        {
          to: "/countryList",
          label: "Country Reg",
          icon: PiHandDeposit,
        },
      ],
    },
  ];

  return (
    <>
      <button
        style={{ top: "1.38rem" }}
        className="fixed left-4 z-20 text-gray-700 lg:hidden"
        onClick={toggleSidebar}
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <div
        ref={sidebarRef}
        className={`w-60 h-screen bg-[#262626] shadow-md px-1 fixed top-0 left-0 z-[999] transition-all duration-300 ease-in-out flex flex-col ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        <div className="border-b border-[#404040]  hidden lg:flex h-[12.5vh] w-full items-center justify-center py-3">
          <img
            alt="logo"
            src="https://api.trubetx.com/uploads/logo/logo.png"
            className="h-10 w-auto"
          />
        </div>
        <nav className="text-sm px-3 py-3 flex flex-col h-full">
          <div className="flex-grow overflow-y-auto pr-1 custom-scrollbar pb-28">
            <div className="mb-4 mt-4 space-y-2">
              {menuItems.map((item, index) =>
                item.allowed ? (
                  item.expandable ? (
                    <div key={index}>
                      <button
                        onClick={() => toggleExpand(item.section!)}
                        className={`group flex items-center justify-between w-full py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#394a6a] hover:bg-gray-100 ${
                          expanded[item.section!]
                            ? "bg-gray-600 font-semibold"
                            : ""
                        }`}
                      >
                        <div
                          className="flex items-center"
                          style={{ paddingTop: "4px", paddingBottom: "4px" }}
                        >
                          <item.icon
                            size={18}
                            className="mr-3 text-white group-hover:text-[#394a6a]"
                          />
                          {item.label}
                        </div>
                        {expanded[item.section!] ? (
                          <ChevronDown
                            size={18}
                            className="group-hover:text-[#394a6a]"
                          />
                        ) : (
                          <ChevronUp
                            size={18}
                            className="group-hover:text-[#394a6a]"
                          />
                        )}
                      </button>
                      <div
                        className={`ml-6 gap-2 overflow-hidden transition-all duration-300 ease-in-out ${
                          expanded[item.section!] ? "" : "max-h-0"
                        }`}
                      >
                        {item.subItems?.map((subItem, subIndex) => (
                          <NavLink
                            key={subIndex}
                            to={subItem.to}
                            className={({ isActive }) =>
                              `group flex items-center px-5 py-3 my-2 rounded-lg transition duration-200 text-[#a3a3a3] text-[16px] hover:text-gray-100 ${
                                isActive
                                  ? "bg-white !text-[#262626] hover:bg-[#8E8E8D]"
                                  : "hover:bg-[#8E8E8D]"
                              }`
                            }
                          >
                            <subItem.icon
                              size={18}
                              className="mr-3 text-[#a3a3a3] group-hover:text-gray-100"
                            />
                            {subItem.label}
                          </NavLink>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <NavLink
                      key={index}
                      to={item.to!}
                      className={({ isActive }) =>
                        `group flex items-center px-5 py-3 my-2 rounded-lg transition duration-200 text-[#a3a3a3] text-[16px] hover:text-gray-100 ${
                          isActive
                            ? "bg-white !text-[#262626] hover:bg-[#8E8E8D]"
                            : "hover:bg-[#8E8E8D]"
                        }`
                      }
                    >
                      <item.icon
                        size={18}
                        className="mr-3 text-[#a3a3a3] group-hover:text-gray-100"
                      />
                      {item.label}
                    </NavLink>
                  )
                ) : null
              )}
            </div>
          </div>
        </nav>
        <div style={{width:"97%"}} className="fixed bottom-0  flex h-16 items-center bg-neutral-800 px-3 shadow-sm shadow-neutral-700 border-t border-[#404040]">
          <button
            onClick={handleLogout}
            className="flex items-center w-full py-3 px-4 text-white hover:text-[#394a6a] hover:bg-gray-100 rounded-lg transition duration-200 text-left"
          >
            <LogOut size={18} className="mr-3" /> Log out
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
